import Vue from 'vue'
import VueRouter from 'vue-router'
import config from '@/config'
import admin from '@/router/module/admin'  //  超级管理员路由
import machine from '@/router/module/MachineMana'  //  机房系统路由

Vue.use(VueRouter)
const constantRouterMap = [
    {
        path: '',
        redirect: '/projectlist'
    },
    {
        path: '/',
        redirect: '/projectlist'
    },
    { path: '/login', component: resolve => require(['@/views/Login/Login'], resolve) },
    // 首页
    {
        path: '/',
        component: resolve => require(['@/views/ProjectList/ProjectLayout'], resolve),
        title: "layout",
        children: [
            { path: '/projectlist', component: resolve => require(['@/views/ProjectList/ProjectList'], resolve), },
            {
                path: '/project-creating',
                component: resolve => require(['@/views/ProjectList/AddProject/AddProject'], resolve),
                name: '新增项目',
                meta: { title: '新增项目' }
            },
			{ path: '/projectsystemlist', component: resolve => require(['@/views/ProjectList/SystemList/SystemList'], resolve), name:'项目子系统列表'},
			{
			    path: '/projectsystem-creating',
			    component: resolve => require(['@/views/ProjectList/SystemList/AddSystem'], resolve),
			    name: '新增项目子系统',
			    meta: { title: '新增项目子系统' }
			},
			
        ]
    },
    // 重写路由结构
    {
        path: '/',
        component: resolve => require(['@/views/Layout/Index'], resolve),
        title: "layout",
        children: [
            // 首页
            { 
                path: '/home', 
                component: resolve => require(['@/views/Home/Home'], resolve), 
                name: '首页',
                meta: { title: '首页' }
            },
           
            // 测试页面
            {
                path: '/testpage',
                component: resolve => require(['@/views/TestPage/TestPage'], resolve),
                name: '测试页面',
                meta: { breadcrumb: [{ menu: '测试页面' }] }
            },
        ],
    },
    // 机房首页
    {
        path: '/machineHome',
        component: resolve => require(['@/views/Home/newHome'], resolve),
        meta: { role: 'machine', system: 1, }
    },
    {
        path: '/machineEditor',
        component: resolve => require(['@/views/MachineMana/Editor/index'], resolve),
        name: 'machineEditor',
        meta: { role: 'machine', system: 1, }
    },
    admin,
    machine,
]

const router = new VueRouter({
    mode: config.ROUTERMODE,
    routes: constantRouterMap
})

export const asyncRouterMap = [
    { path: '/401', component: resolve => require(['@/views/ErrorPage/401'], resolve) },
    { path: '/404', component: resolve => require(['@/views/ErrorPage/404'], resolve) },
    { path: '*', redirect: '/404' }
]
export default router;